module.exports = __webpack_public_path__ + "images/assets/c8936496418fb9704435c6ea4ebdd381.svg";